import { CSSProperties, FC } from 'react';

type Props = {
  /** Заливка образца; без неё образец пустой — так помечена середина шкалы */
  style?: CSSProperties;
  label: string;
};

/** Метка легенды: образец заливки и подпись. */
export const LegendSwatch: FC<Props> = ({ style, label }) => (
  <span className="flex items-center gap-1.5">
    <span className="size-3 rounded-sm border border-border" style={style} />
    <span className="text-xs text-muted-foreground">{label}</span>
  </span>
);
